module.exports = __webpack_public_path__ + "img/Setting-B.a844d3df.svg";